export enum PaymentTransactionColumns {
  Status = 'Status',
  ReferenceNumber = 'Reference No',
  Date = 'Date',
  AccountNumber = 'Account Number',
  Direction = 'Direction',
  TypeOfTransfer = 'Type of Transfer',
  Description = 'Description',
  SenderIban = 'Sender IBAN',
  BeneficiaryIban = 'Beneficiary IBAN',
  Currency = 'Currency',
  ExchangeRate = 'Exchange Rate',
  SenderAmount = 'Sender Amount',
  BeneficiaryAmount = 'Beneficiary Amount',
  Fee = 'Fee',
  TotalAmount = 'Total Amount',
}
